import useWorkspacesMemberInOrganization from './useWorkspacesMemberInOrganization';
import useWorkspacesPublicInOrganization from './useWorkspacesPublicInOrganization';
import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';
import { APPLICATION_TYPE } from '@/shared/constants';

export default function useWorkspaces() {
  const { user: currentUser } = useCurrentUserContext();

  const {
    data: memberWorkspaces = [],
    isLoading: memberWorkspacesLoading,
    isFetching: memberWorkspacesFetching
  } = useWorkspacesMemberInOrganization();

  const {
    data: publicWorkspaces = [],
    isLoading: publicWorkspacesLoading,
    isFetching: publicWorkspacesFetching
  } = useWorkspacesPublicInOrganization({
    enabled: !!currentUser?.userAppType
  });

  const isLoading = memberWorkspacesLoading || publicWorkspacesLoading;
  const isFetching = memberWorkspacesFetching || publicWorkspacesFetching;

  const combinedWorkspaces =
    currentUser?.userAppType === APPLICATION_TYPE.llm
      ? memberWorkspaces
      : [...memberWorkspaces, ...publicWorkspaces];

  return { data: combinedWorkspaces, isLoading, isFetching };
}
